<div class="page-header" *ngIf="!isModal">
  <div class="page-title">
    <h3>
      {{
        !createMode
          ? ('LOCATION' | translate) + ' / ' + location.name
          : ('NEW_LOCATION' | translate)
      }}
    </h3>
  </div>
  <div class="pull-right">
    <div class="form-actions no-wrap">
      <app-item-detail-form-actions
        [createMode]="createMode"
        [disableSaveItem]="sendingForm"
        [sendingForm]="sendingForm"
        [viewMode]="viewMode"
        (canceled)="onCanceled()"
        (edited)="onEditedLocation()"
        (saved)="onSavedLocation()"
      >
      </app-item-detail-form-actions>
      <!-- || -->
      <!-- (!loadingLocations && locations.length === 0) || -->
      <!-- (!loadingZones && zones.length === 0) -->
    </div>
  </div>
</div>

<!-- <div
  class="alert alert-danger fade in"
  *ngIf="(!loadingLocations && locations.length === 0) || (!loadingZones && zones.length === 0)"
>
  <h4>{{ 'PLEASE_CORRECT_ERRORS' | translate }}</h4>
  <button
    type="button"
    class="btn btn-inverse"
    (click)="openLocationsModal()"
    *ngIf="locations.length === 0"
  >
    <i class="fa fa-plus"></i> {{ 'ADD_LOCATION' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-inverse"
    (click)="openZonesModal()"
    *ngIf="zones.length === 0"
  >
    <i class="fa fa-plus"></i> {{ 'ADD_ZONE' | translate }}
  </button>
</div> -->

<form [formGroup]="form" class="form-horizontal no_marginxx" autocomplete="off" novalidate>
  <app-translation-options
    [defaultLanguage]="defaultLanguage"
    [additionalLanguages]="additionalLanguages"
    (openedTranslation)="onOpenedTranslation($event)"
    *ngIf="!createMode && additionalLanguages.length > 0"
  ></app-translation-options>
  <div class="widget">
    <div class="widget-header">
      <h4>{{ 'LOCATION_DETAILS' | translate }}</h4>
    </div>
    <div class="widget-content form-vertical no-margin">
      <div class="row">
        <div class="col-md-4 col-lg-3">
          <span *ngIf="location.logoUrl">
            <a fancybox class="fancybox" href="{{ location.logoUrl }}" title="{{ location.name }}">
              <img
                [src]="location.logoUrl"
                alt="{{ location.name }}"
                title="{{ 'ENLARGE_PHOTO' | translate }}"
                class="img-center"
              />
            </a>
          </span>
          <span *ngIf="!location.logoUrl" class="default-img img-center">
            <img id="logo-image-preview" class="img-center" />
          </span>

          <div class="logo_bar" [hidden]="viewMode">
            <button
              type="button"
              class="btn btn-xs btn-danger"
              (click)="openLogo()"
              title="{{ labelAddLogo | translate }}"
              [disabled]="editMode && form.invalid"
            >
              <i class="fa" [ngClass]="editMode ? 'fa-pencil' : 'fa-plus'"></i>
            </button>
          </div>
        </div>
        <div class="col-md-8 col-lg-9">
          <div class="row">
            <div class="col-md-6">
              <!-- Name -->
              <div class="form-group">
                <label class="control-label">
                  {{ 'NAME' | translate }} <span class="required" [hidden]="viewMode">*</span>
                </label>
                <div *ngIf="viewMode" class="form-label">
                  {{ location.name }}
                </div>
                <div *ngIf="!viewMode">
                  <input type="text" class="form-control" formControlName="name" maxlength="255" />
                  <!-- (keyup)="generateUrl($event)" -->
                  <app-form-errors
                    [control]="form.controls['name']"
                    [formSubmited]="formSubmited"
                  ></app-form-errors>
                  <app-form-server-errors [error]="serverErrors['name']"></app-form-server-errors>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <!-- Url -->
              <div class="form-group">
                <label class="control-label">
                  {{ 'URL_ADDRESS' | translate }}
                  <span class="required" [hidden]="viewMode">*</span>
                </label>
                <div [hidden]="!viewMode" class="form-label">
                  {{ location.url }}
                </div>
                <div [hidden]="viewMode">
                  <div class="input-group">
                    <input type="text" class="form-control" formControlName="url" maxlength="255" />
                    <span class="input-group-btn">
                      <button type="button" class="btn" (click)="generateUrl()">
                        <i class="fa fa-link" title="{{ 'GENERATE_URL' | translate }}"></i>
                      </button>
                    </span>
                  </div>
                  <app-form-errors
                    [control]="form.controls['url']"
                    [formSubmited]="formSubmited"
                  ></app-form-errors>
                  <app-form-server-errors [error]="serverErrors['url']"></app-form-server-errors>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->

          <!-- Short description -->
          <div class="form-group">
            <label class="control-label">{{ 'SHORT_DESCRIPTION' | translate }}</label>
            <div [hidden]="!viewMode" class="form-label">
              {{ location.short_description || '-' }}
            </div>
            <div [hidden]="viewMode">
              <textarea
                class="form-control"
                formControlName="short_description"
                rows="3"
              ></textarea>
            </div>
          </div>

          <!-- Long description -->
          <div class="form-group">
            <label class="control-label">{{ 'LONG_DESCRIPTION' | translate }}</label>
            <div [hidden]="!viewMode" class="form-label">
              <!-- <div -->
              <!-- [innerHTML]="location.long_description" -->
              <!-- [hidden]="!location.long_description" -->
              <!-- ></div> -->
              <!-- <div [hidden]="location.long_description">-</div> -->

              <div [innerHTML]="location.long_description" *ngIf="location.long_description"></div>
              <div *ngIf="!location.long_description">-</div>
            </div>
            <div [hidden]="viewMode">
              <!-- <textarea class="form-control" formControlName="long_description" rows="3"></textarea> -->
              <div class="NgxEditor__Wrapper">
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                <ngx-editor
                  [editor]="editor"
                  formControlName="long_description"
                  [placeholder]="''"
                ></ngx-editor>
              </div>
            </div>
          </div>

          <!-- Highlights -->
          <div class="form-group">
            <label class="control-label">{{ 'HIGHLIGHTS' | translate }}</label>
            <div [hidden]="!viewMode" class="form-label">
              {{ location.highlights || '-' }}
            </div>
            <div [hidden]="viewMode">
              <textarea class="form-control" formControlName="highlights" rows="3"></textarea>
            </div>
          </div>

          <!-- Video -->
          <div class="form-group">
            <label class="control-label">{{ 'VIDEO' | translate }}</label>
            <div [hidden]="!viewMode" class="form-label">
              {{ location.url_video || '-' }}
            </div>
            <div [hidden]="viewMode">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="url_video"
                  maxlength="255"
                />
                <span class="input-group-btn" *ngIf="!createMode && urlEmbedVideo">
                  <a
                    fancybox
                    class="btn fancybox fancybox.iframe"
                    href="{{ urlEmbedVideo }}"
                    title="{{ 'WATCH_VIDEO' | translate }}"
                  >
                    <i class="fa fa-video-camera"></i>
                  </a>
                </span>
                <span class="input-group-addon">Youtube</span>
              </div>
              <app-form-errors
                [control]="form.controls['url_video']"
                [formSubmited]="formSubmited"
              ></app-form-errors>

              <!-- <div
                class="error-messages"
                ng-if="vm.UtilService.interacted(form.url_video)"
                ng-messages="form.url_video.$error"
              >
                <div ng-message="pattern">{{ 'INVALID_CHARACTERS' | translate }}</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </div>
    <!-- /.widget-content -->
  </div>
  <!-- /.widget -->

  <br />
  <div class="widget">
    <div class="widget-header">
      <h4>{{ 'DETAILS' | translate }}</h4>

      <div class="toolbar" *ngIf="!viewMode">
        <div class="btn-group">
          <span class="dropdown-toggle btn btn-xs" data-toggle="dropdown">
            <i class="fa fa-cog"></i>
          </span>
          <ul class="dropdown-menu pull-right">
            <li>
              <a href (click)="openCategoriesModal()">
                <i class="fa fa-map-marker fa-sized"></i> {{ 'EDIT_CATEGORIES' | translate }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="widget-content">
      <!-- Category -->
      <div class="form-group">
        <label class="col-md-3 control-label">
          <span class="required" [hidden]="viewMode">*</span> {{ 'CATEGORY' | translate }}
        </label>
        <div class="col-md-6">
          <div *ngIf="viewMode" class="form-label-transparent">
            <span *ngFor="let categoty of location.categories">
              <span class="label label-default label-md">{{ categoty.name }}</span
              >&nbsp;
            </span>
          </div>
          <div *ngIf="!viewMode">
            <mat-select
              formControlName="category_ids"
              placeholder="{{ 'SELECT_CATEGORY' | translate }}"
              multiple
            >
              <mat-option *ngFor="let category of categories" [value]="category.id">
                {{ category.name }}
              </mat-option>
            </mat-select>
            <app-form-errors
              [control]="form.controls['category_ids']"
              [formSubmited]="formSubmited"
            ></app-form-errors>
          </div>
        </div>
      </div>

      <hr />

      <!-- Country -->
      <div class="form-group">
        <label class="col-md-3 control-label">
          <span class="required" [hidden]="viewMode">*</span> {{ 'COUNTRY' | translate }}
        </label>
        <div class="col-md-6">
          <div *ngIf="viewMode" class="form-label">
            {{ location.country.name }}
          </div>
          <div *ngIf="!viewMode">
            <div *ngIf="!loadingCountries">
              <ng-select
                [items]="countries"
                [clearable]="false"
                bindLabel="name"
                bindValue="id"
                placeholder="{{ 'SELECT_COUNTRY' | translate }}"
                formControlName="country_id"
              >
              </ng-select>
              <app-form-errors
                [control]="form.controls['country_id']"
                [formSubmited]="formSubmited"
              ></app-form-errors>
            </div>
            <div *ngIf="loadingCountries" class="form-label text-muted">
              {{ 'LOADING' | translate }}...
            </div>
          </div>
        </div>
      </div>

      <!-- Parent location -->
      <div class="form-group">
        <label class="col-md-3 control-label">
          <span class="required" [hidden]="viewMode">*</span> {{ 'PARENT_LOCATION' | translate }}
        </label>
        <div class="col-md-6">
          <div *ngIf="viewMode" class="form-label">
            {{ location.parentLocation ? location.parentLocation.name : '' }}
            <small *ngIf="location.is_superior_location">
              ({{ 'SUPERIOR_LOCATION' | translate }})
            </small>
          </div>
          <div *ngIf="!viewMode">
            <div *ngIf="!loadingLocations">
              <!-- <ng-select
                [clearable]="false"
                placeholder="{{ 'SELECT' | translate }}"
                formControlName="parentLocation_id"
              >
                <ng-option *ngFor="let location of locations" [value]="location.id">
                  <span class="treelevel-{{ location.treelevel }}">
                    {{ location.name }}
                    <small *ngIf="location.id && location.is_superior_location">
                      ({{ 'SUPERIOR_LOCATION' | translate }})
                    </small>
                  </span>
                </ng-option>
              </ng-select> -->

              <ng-select
                [items]="groupedLocations"
                [clearable]="false"
                [selectableGroup]="true"
                [compareWith]="compareLocations"
                groupBy="parent"
                bindLabel="name"
                bindValue="id"
                placeholder="{{ 'SELECT' | translate }}"
                formControlName="parentLocation_id"
              >
                <ng-template ng-option-tmp let-item="item">
                  <div class="treelevel-{{ item.treelevel }}">
                    {{ item.name }}
                    <small *ngIf="item.id && item.is_superior_location">
                      ({{ 'SUPERIOR_LOCATION' | translate }})
                    </small>
                  </div>
                </ng-template>
              </ng-select>

              <app-form-errors
                [control]="form.controls['parentLocation_id']"
                [formSubmited]="formSubmited"
              ></app-form-errors>
            </div>
            <div *ngIf="loadingLocations" class="form-label text-muted">
              {{ 'LOADING' | translate }}...
            </div>
          </div>
        </div>
        <div class="col-md-3 nopadding_left" [hidden]="viewMode">
          <label class="control control-checkbox">
            <input
              type="checkbox"
              formControlName="is_superior_location"
              (change)="setSuperLocation()"
            />
            <span>{{ 'SUPERIOR_LOCATION' | translate }}</span>
            <div class="control-indicator"></div>
          </label>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-3 control-label">{{ 'GEO_COORDINATES' | translate }}</label>
        <div class="col-md-9">
          <div *ngIf="googleMapLoaded">
            <app-map
              [lat]="location.geo_lat"
              [lng]="location.geo_lng"
              [zoom]="location.geo_zoom"
              [viewMode]="viewMode"
              (selectedMapPlace)="onSelectedMapPlace($event)"
            ></app-map>
          </div>
        </div>
      </div>

      <!-- Coordinates -->
      <div class="form-group">
        <div class="col-md-9 col-md-offset-3">
          <div class="row">
            <div class="col-md-4">
              {{ 'LATITUDE' | translate }}
              <div *ngIf="viewMode" class="form-label">
                {{ location.geo_lat || '-' }}
              </div>
              <div *ngIf="!viewMode">
                <input
                  type="text"
                  class="form-control"
                  formControlName="geo_lat"
                  placeholder="{{ 'ENTER_LATITUDE' | translate }}"
                  maxlength="50"
                />
                <!-- allow-pattern="map" -->
              </div>
            </div>
            <div class="col-md-4">
              {{ 'LONGITUDE' | translate }}
              <div *ngIf="viewMode" class="form-label">
                {{ location.geo_lng || '-' }}
              </div>
              <div *ngIf="!viewMode">
                <input
                  type="text"
                  class="form-control"
                  formControlName="geo_lng"
                  placeholder="{{ 'ENTER_LONGITUDE' | translate }}"
                  maxlength="50"
                />
                <!-- allow-pattern="map" -->
              </div>
            </div>
            <div class="col-md-4">
              {{ 'ZOOM' | translate }}
              <div *ngIf="viewMode" class="form-label">
                {{ location.geo_zoom || '-' }}
              </div>
              <div *ngIf="!viewMode">
                <input
                  type="number"
                  class="form-control"
                  formControlName="geo_zoom"
                  placeholder="{{ 'ENTER_ZOOM' | translate }}"
                  [appInputNumberMaxLength]="2"
                />
                <!-- allow-pattern="currency" -->
                <!-- number-converter -->
                <app-form-errors
                  [control]="form.controls['geo_zoom']"
                  [formSubmited]="formSubmited"
                ></app-form-errors>
                <!-- INVALID_NUMBER -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.widget-content -->
  </div>
  <!-- /.widget -->

  <!-- <div class="widget" ng-if="!vm.createMode">
    <div class="widget-header">
      <h4>{{ 'PHOTOS' | translate }}</h4>
    </div>
    <div class="widget-content">
      <photo-list item-id="vm.item.id" items="vm.item.photos" model="locations"> </photo-list>
    </div>
  </div> -->
  <!-- /.widget -->

  <div class="form-actions no-wrap">
    <app-item-detail-form-actions
      [createMode]="createMode"
      [disableSaveItem]="sendingForm"
      [sendingForm]="sendingForm"
      [viewMode]="viewMode"
      (canceled)="onCanceled()"
      (edited)="onEditedLocation()"
      (saved)="onSavedLocation()"
    >
    </app-item-detail-form-actions>
  </div>
</form>

<!-- <mat-select
                formControlName="country_id"
                placeholder="{{ 'SELECT_COUNTRY' | translate }}"
              >
                <mat-option *ngFor="let country of countries" [value]="country.id">
                  {{ country.name }}
                </mat-option>
              </mat-select> -->

<!-- <mat-select
                formControlName="parentLocation_id"
                placeholder="{{ 'SELECT' | translate }}"
              >
                <mat-option *ngFor="let location of locations" [value]="location.id">
                  <div class="treelevel-{{ location.treelevel }}">
                    {{ location.name }}-{{ location.treelevel }}
                    <small *ngIf="location.id && location.is_superior_location">
                      ({{ 'SUPERIOR_LOCATION' | translate }})
                    </small>
                  </div>
                </mat-option>
              </mat-select> -->

<!-- <angular2-multiselect
                [data]="countries"
                [(ngModel)]="countrySelected"
                [settings]="settings"
                formControlName="country_id"
              >
              </angular2-multiselect> -->

<!-- (onSelect)="onItemSelect($event)" -->

<!-- <input
                type="text"
                class="form-control"
                placeholder="{{ 'SEARCH' | translate }}"
                matInput
                [formControl]="myControl"
              /> -->
<!-- [matAutocomplete]="auto" -->
<!-- #auto="matAutocomplete" -->

<!-- <mat-select
                formControlName="country_id"
                placeholder="{{ 'SELECT_COUNTRY' | translate }}"
              >
                <mat-option><input (keyup)="onKey($event)" /></mat-option> -->

<!-- #countrySelect -->
<!-- [(value)]="form.controls['country_id']" -->
<!-- <mat-option>
                  <ngx-mat-select-search [formControl]="bankFilterCtrl"></ngx-mat-select-search>
                </mat-option> -->

<!-- <mat-select-trigger>{{ countrySelect.value.name }}</mat-select-trigger> -->
<!-- <mat-select-trigger>{{ countrySelected.name }}</mat-select-trigger> -->

<!-- <mat-option *ngFor="let country of countries" [value]="country.id">
                  {{ country.name }}
                </mat-option>
              </mat-select> -->
